import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-6 ms-1" }, "close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "selected-brand btn btn-sm btn-green d-flex justify-content-between align-items-center fs-7 lh-sm text-white text-wrap fw-bold m-1 pe-1",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.removeBrand(this.selectedBrandCode)), ["prevent"]))
  }, [
    _createElementVNode("span", null, _toDisplayString(this.brandName?.toUpperCase()), 1),
    _hoisted_1
  ]))
}